import React from "react";

import { ProfileDataBlockProps } from "@models/components/user.model";

const ProfileDataBlock: React.FC<ProfileDataBlockProps> = ({
  contactType,
  customClassName,
  data,
}) => {
  return (
    <div className={customClassName} data-testid="profile-data-block">
      <ul className="fg-address-det">
        {data?.map(item => {
          if (contactType && item?.hideFor?.includes(contactType)) {
            return;
          }

          return (
            <li data-testid="profile-data-item" key={item.label}>
              <strong>{item.label}: </strong>
              {item?.value ? item?.value : "-"}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProfileDataBlock;
